import { render, staticRenderFns } from "./botao-detalhe.vue?vue&type=template&id=4419b7a8&scoped=true"
import script from "./botao-detalhe.vue?vue&type=script&lang=js"
export * from "./botao-detalhe.vue?vue&type=script&lang=js"
import style0 from "./botao-detalhe.vue?vue&type=style&index=0&id=4419b7a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4419b7a8",
  null
  
)

export default component.exports